import axios from "axios";

const API_BASE_URL = "https://alura-plum-phi.vercel.app";
// const API_BASE_URL = "http://localhost:8080";

// Axios instance
const api = axios.create({
    baseURL: API_BASE_URL,
});

// Reusable API call function
export const apiCall = async (endpoint, method = "GET", data = null, headers = {}) => {
    try {
        //Check this is Form Data Or Not
        const isFormData = data instanceof FormData;
        const token = localStorage.getItem("AluraToken");
        const authHeader = token ? { Authorization: `Bearer ${token}` } : {};

        const response = await api({
            url: endpoint,
            method,
            data,
            headers: {
                ...headers, 
                ...(isFormData ? {authHeader} : { "Content-Type": "application/json", ...authHeader }),
            },
        });

        return response.data;
    } catch (error) {
        console.error("API Call Error:", error);
        throw error; 
    }
};
